export const isEllipsisActive = (element: HTMLElement) => {
  return element.offsetWidth < element.scrollWidth;
};
